import React from "react";
import {SparkLineChart} from "@mui/x-charts-pro";
import CCMuiValueChart from "./CCMuiValueChart";

class CCSparkline extends CCMuiValueChart {
    static ATTR_MAP: [string, string][] = [
        ["Area", "area"],
        ["Color", "color"],
        ["Colors", "colors"],
        ["Curve", "curve"],
        ["Height", "height"],
        ["Id", "id"],
        ["Margin", "margin"],
        ["PlotType", "plotType"],
        ["ShowHighlight", "showHighlight"],
        ["ShowTooltip", "showTooltip"],
        ["SkipAnimation", "skipAnimation"],
        ["ValueFormatter", "valueFormatter"],
        ["Width", "width"],
    ];

    constructor(props: any) {
        super(props);

        this.state.Data = props.data ?? [];
    }

    renderChart(chartProps: any): React.ReactNode {
        return <SparkLineChart {...chartProps} data={this.state.Data} sx={this.props.sx} />;
    }
}

export default CCSparkline;
